import { TextBlockParser as n } from "./text-block-parser.js";
import { BLOCK_TYPES as s, DEFAULT_ALIGNMENT as r } from "./constants.js";
import { d as a } from "./_virtual/index.js";
import { getResponsiveClasses as h } from "./utils/tables.js";
class B {
  constructor(e, t) {
    this.documentBuilder = e, this.config = t, this.schema = e.schema, this.textBlockParser = new n(e, t);
  }
  schema;
  textBlockParser;
  handle(e, t) {
    switch (e.type) {
      case s.ORDERED_NESTED_LIST:
      case s.UNORDERED_NESTED_LIST:
        this.nestedList(e);
        break;
      case s.PARAGRAPH:
      case s.ORDERED_LIST:
      case s.UNORDERED_LIST:
      case s.HEADING:
      case s.SUBHEADING:
      case s.SUBHEADING3:
      case s.SUBHEADING4:
      case s.SMALL:
      case s.CODE:
        this.textBlockParser.handle(e, t);
        break;
      case s.HTML:
        this.html(e);
        break;
      case s.HORIZONTAL_RULE:
        this.horizontalRule(e);
        break;
      case s.IMAGE:
        this.image(e);
        break;
      case s.IMAGE_TEXT:
        this.imageText(e);
        break;
      case s.VIDEO:
        this.video(e);
        break;
      case s.VIDEO_FILE:
        this.videoFile(e);
        break;
      case s.AUDIO_FILE:
        this.audioFile(e);
        break;
      case s.BUTTON:
        this.button(e);
        break;
      case s.MESSENGER_CARD:
        this.messengerCard(e);
        break;
      case s.TABLE:
        this.table(e);
        break;
      case s.IF_ELSE_STATEMENT:
        this.ifElseStatement(e);
        break;
      case s.TWITTER_FOLLOW_BUTTON:
        this.twitterFollowButton(e);
        break;
      case s.FACEBOOK_LIKE_BUTTON:
        this.facebookLikeButton(e);
        break;
      case s.SOCIAL:
        this.social(e);
        break;
      case s.SPACER:
        this.spacer(e);
        break;
      case s.CALLOUT:
        this.callout(e);
        break;
      case s.COLLAPSIBLE_SECTION:
        this.collapsibleSection(e);
        break;
      case s.UNSUPPORTED_ELEMENT:
        this.unsupportedElement(e);
        break;
    }
  }
  table(e) {
    const t = this.schema.nodes.table;
    if (t) {
      let i = {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        responsive: e.responsive || !1,
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        container: e.container || !1,
        sectionType: e.sectionType
      };
      typeof e.stacked == "boolean" && (i.stacked = e.stacked);
      const o = this.getPaddingAttrs(e);
      i = {
        ...i,
        backgroundColor: this.addBackgroundColor(e) ?? "",
        borderRadius: this.addBorderRadius(e) ?? "",
        ...o
      }, this.documentBuilder.openNode(t, i), e.rows.forEach((d) => this.tableRow(d, i)), this.documentBuilder.closeNode();
    }
  }
  tableRow(e, t) {
    const i = this.schema.nodes.tableRow;
    if (i) {
      let o = t.responsive ? { responsiveClasses: h(e.cells.length) } : {};
      o = t.container ? { ...o, container: !0 } : o, this.documentBuilder.openNode(i, {}), e.cells.forEach((d) => this.tableCell(d, o)), this.documentBuilder.closeNode();
    }
  }
  tableCell(e, t) {
    const i = this.schema.nodes.tableCell;
    if (i) {
      if (t.container) {
        const o = this.getPaddingAttrs(e);
        t = {
          ...t,
          ...o
        };
      }
      !t.container && !t.responsive && (t = {
        ...t,
        backgroundColor: this.addBackgroundColor(e) ?? ""
      }), e.displayWidth && (t = {
        ...t,
        colwidth: [e.displayWidth]
      }), this.documentBuilder.openNode(i, t), t.container && e.content.length === 0 && this.schema.nodes.placeholder && this.placeholder(), e.content.forEach((o) => this.handle(o)), this.documentBuilder.closeNode();
    }
  }
  social(e) {
    const t = this.schema.nodes.social;
    t && (this.documentBuilder.openNode(t, {
      alignment: this.alignmentClass(e),
      items: e.items
    }), this.documentBuilder.closeNode());
  }
  spacer(e) {
    const t = this.schema.nodes.spacer;
    t && (this.documentBuilder.openNode(t, {
      height: e.height
    }), this.documentBuilder.closeNode());
  }
  callout(e) {
    const t = this.schema.nodes.callout;
    t && (this.documentBuilder.openNode(t, {
      type: e.type,
      backgroundColor: this.addBackgroundColor(e) ?? "",
      borderColor: this.addBorderColor(e) ?? ""
    }), e.content.forEach((i) => this.handle(i)), this.documentBuilder.closeNode());
  }
  unsupportedElement(e) {
    const t = this.schema.nodes.unsupportedElement;
    t && (this.documentBuilder.openNode(t, {
      type: e.type,
      unsupportedTypeName: e.unsupportedTypeName,
      text: e.text
    }), this.documentBuilder.closeNode());
  }
  placeholder(e = {}) {
    this.documentBuilder.openNode(this.schema.nodes.placeholder, e), this.documentBuilder.closeNode();
  }
  nestedList(e) {
    const t = this.schema.nodes[e.type];
    t && (this.documentBuilder.openNode(t, {}), e.items.forEach((i) => this.nestedListItem(i)), this.documentBuilder.closeNode());
  }
  nestedListItem(e) {
    const t = this.schema.nodes.nestedListItem;
    t && (this.documentBuilder.openNode(t, {}), e.content.forEach((i) => this.handle(i)), this.documentBuilder.closeNode());
  }
  ifElseStatement(e) {
    const t = this.schema.nodes.ifElseStatement;
    t && (this.documentBuilder.openNode(t, {
      predicatesBlocksPairs: e.predicatesBlocksPairs,
      fallbackBlocks: e.fallbackBlocks
    }), this.documentBuilder.closeNode());
  }
  twitterFollowButton(e) {
    const t = this.schema.nodes.twitterFollowButton;
    t && (this.documentBuilder.openNode(t, {
      username: e.username
    }), this.documentBuilder.closeNode());
  }
  facebookLikeButton(e) {
    const t = this.schema.nodes.facebookLikeButton;
    t && (this.documentBuilder.openNode(t, {
      url: e.url
    }), this.documentBuilder.closeNode());
  }
  image(e) {
    const t = this.schema.nodes.image;
    if (t) {
      const i = e.url, d = {
        // Use placeholder if URL is invalid, otherwise use the original URL
        src: i && typeof i == "string" && i.trim() !== "" ? i : this.config.images?.failedImageUrl ?? "",
        linkUrl: e.linkUrl,
        text: e.text,
        width: e.width,
        displayWidth: e.displayWidth,
        height: e.height,
        alignment: this.alignmentClass(e)
      };
      this.documentBuilder.openNode(t, d), this.documentBuilder.closeNode();
    }
  }
  imageText(e) {
    const t = this.schema.nodes.imageText;
    t && (this.documentBuilder.openNode(t, {
      imageUrl: e.imageUrl,
      title: "title" in e ? e.title : "",
      text: e.text
    }), this.documentBuilder.closeNode());
  }
  video(e) {
    const t = this.schema.nodes.video;
    if (t) {
      const i = "videoId" in e ? e.videoId : e.id;
      this.documentBuilder.openNode(t, {
        type: e.type,
        provider: e.provider,
        id: i
      }), this.documentBuilder.closeNode();
    }
  }
  videoFile(e) {
    const t = this.schema.nodes.videoFile;
    t && (this.documentBuilder.openNode(t, {
      type: e.type,
      thumbnailUrl: e.thumbnailUrl,
      url: e.url,
      captions: e.captions
    }), this.documentBuilder.closeNode());
  }
  audioFile(e) {
    const t = this.schema.nodes.audioFile;
    t && (this.documentBuilder.openNode(t, {
      type: e.type,
      url: e.url
    }), this.documentBuilder.closeNode());
  }
  button(e) {
    const t = this.schema.nodes.button, i = this.unescapeExpression(e.text);
    if (t) {
      const o = this.getPaddingAttrs(e);
      this.documentBuilder.openNode(t, {
        type: e.type,
        linkUrl: e.linkUrl,
        buttonStyle: e.buttonStyle || "solid",
        alignment: this.alignmentClass(e),
        fontFamily: this.addFontFamily(e) ?? "",
        fontColor: this.addFontColor(e) ?? "",
        backgroundColor: this.addBackgroundColor(e) ?? "",
        ...o,
        borderRadius: this.addBorderRadius(e) ?? "",
        text: i
      }), this.documentBuilder.closeNode();
    }
  }
  unescapeExpression(e) {
    const t = document.createElement("div");
    return t.innerHTML = a.sanitizeHtml(e), t.textContent || "";
  }
  horizontalRule(e) {
    const t = this.schema.nodes.horizontalRule;
    t && (this.documentBuilder.openNode(t, {
      type: e.type,
      text: e?.text,
      width: e?.width ?? "",
      borderColor: this.addBorderColor(e) ?? "",
      borderWidth: this.addBorderWidth(e) ?? "",
      borderStyle: this.addBorderStyle(e) ?? ""
    }), this.documentBuilder.closeNode());
  }
  collapsibleSection(e) {
    const t = this.schema.nodes.collapsibleSection;
    t && (this.documentBuilder.openNode(t, {}), this.collapsibleSectionSummary(e), this.collapsibleSectionContent(e), this.documentBuilder.closeNode());
  }
  collapsibleSectionSummary(e) {
    const t = this.schema.nodes.collapsibleSectionSummary;
    t && (this.documentBuilder.openNode(t, {}), this.handle(e.summary), this.documentBuilder.closeNode());
  }
  collapsibleSectionContent(e) {
    const t = this.schema.nodes.collapsibleSectionContent;
    t && (this.documentBuilder.openNode(t, {}), e.content.forEach((i) => this.handle(i)), this.documentBuilder.closeNode());
  }
  html(e) {
    const t = this.schema.nodes.html;
    t && (this.documentBuilder.openNode(t, { content: e.content }), this.documentBuilder.closeNode());
  }
  messengerCard(e) {
    const t = this.schema.nodes.messengerCard;
    t && (this.documentBuilder.openNode(t, {
      canvas: e.canvas,
      text: e.text,
      messenger_app_id: e.messenger_app_id,
      uri: e.uri
    }), this.documentBuilder.closeNode());
  }
  alignmentClass(e) {
    return "align" in e ? e.align : r;
  }
  addFontFamily(e) {
    if ("style" in e)
      return e.style?.fontFamily;
  }
  addFontColor(e) {
    if ("style" in e)
      return e.style?.fontColor;
  }
  // TODO: interblocks.ts should export Stylable type
  addBackgroundColor(e) {
    if ("style" in e)
      return e.style?.backgroundColor;
  }
  addBorderColor(e) {
    if ("style" in e)
      return e.style?.borderColor;
  }
  addBorderStyle(e) {
    if ("style" in e)
      return e.style?.borderStyle;
  }
  addBorderWidth(e) {
    if ("style" in e)
      return e.style?.borderWidth;
  }
  getPaddingAttrs(e) {
    return "style" in e ? {
      paddingTop: e.style?.paddingTop ?? "",
      paddingBottom: e.style?.paddingBottom ?? "",
      paddingLeft: e.style?.paddingLeft ?? "",
      paddingRight: e.style?.paddingRight ?? ""
    } : {};
  }
  addBorderRadius(e) {
    if ("style" in e)
      return e.style?.borderRadius;
  }
}
export {
  B as BlockParser
};
